export const redactString = (
  str: string = '',
  {
    mask = '...',
    mode = 'middle',
  }: {
    mask?: string;
    mode?: 'full' | 'middle';
  } = {
    mask: '...',
    mode: 'middle',
  },
) => {
  const maskLength = mask.length;
  const strLength = str.length;

  if (mode === 'middle') {
    const sliceSize = Math.min(
      maskLength,
      str.length - maskLength > 1 ? (strLength - maskLength) / 2 : 0,
    );

    return `${str.slice(0, sliceSize)}${mask}${
      sliceSize > 0 ? str.slice(-sliceSize) : ''
    }`;
  } else {
    return str.replace(/\w/g, mask[0] || '');
  }
};

export const redactObject = (obj: any, keysToRedact: string[]): any => {
  if (typeof obj === 'object' && obj !== null) {
    const result: any = {};

    for (const [key, value] of Object.entries(obj)) {
      if (keysToRedact.includes(key)) {
        if (typeof value === 'string') {
          result[key] = redactString(value);
        } else if (Array.isArray(value)) {
          if (value.every(item => typeof item === 'string')) {
            result[key] = value.map(item => redactString(item));
          } else {
            result[key] = value.map(item => redactObject(item, keysToRedact));
          }
        } else {
          result[key] = value;
        }
      } else {
        result[key] = redactObject(value, keysToRedact);
      }
    }

    return result;
  } else {
    return obj;
  }
};
